import { Component, OnDestroy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgIf } from '@angular/common';

@Component({
  selector: 'pt-error-cve-dialog',
  template: `
    <div class="modal-header">
      <div class="h4 modal-title" [innerHTML]="'TITLE.MISSING_CVE' | translate"></div>
    </div>

    <div class="modal-body">
      <div *ngIf="errorMessage" [innerHTML]="errorMessage | translate"></div>
    </div>

    <div class="modal-footer">
      <div class="w-100 d-flex justify-content-end">
        <button (click)="close()" class="btn btn-sm btn-outline-secondary">
          {{ "BUTTON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  `,
  styles: [`

  `],
  imports: [
    TranslateModule,
    NgIf
  ],
  standalone: true
})
export class ErrorCveDialogComponent implements OnDestroy {
  public errorMessage?: string;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnDestroy(): void {
    this.close();
  }

  showMessage(message: string) {
    this.errorMessage = message;
  }

  close() {
    this.activeModal.close(true);
  }

}
